import { useContext } from 'react';

import { UserProfileProviderContext } from '@/providers/UserProfileProvider';

export const useUserProfile = () => useContext(UserProfileProviderContext);
